import { render, staticRenderFns } from "./CompanyDigitalAssets.vue?vue&type=template&id=a361a2dc&"
import script from "./CompanyDigitalAssets.vue?vue&type=script&lang=js&"
export * from "./CompanyDigitalAssets.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDigitalAssets.vue?vue&type=style&index=0&id=a361a2dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports